import PositionDetails from "./PositionDetails";
export default PositionDetails;